import { en_ca } from "../en_ca";

export const en_ca_snf = {
  ...en_ca
};
